import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';


// 引入图片（确保这些文件在 src/images 下）
import banner from '../images/banner.jpg';
import expo1 from '../images/expo1.jpg'; // 2024 环球资源展会
import expo2 from '../images/expo2.jpg'; // 2024 环球资源展会细节
import expo3 from '../images/expo3.jpg'; // 2019 广交会展会细节
import expo4 from '../images/expo4.jpg'; // 2018 香港展会
import expo5 from '../images/expo5.jpg'; // 2017 香港展会
import expo6 from '../images/expo6.jpg'; // 2016 香港展会


// 页面容器
const NewsContainer = styled.div`
  width: 100%;
`;


// Banner 区域
const BannerSection = styled.section`
  width: 100%;
  background-color: #0099ff;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
`;


const BannerImage = styled.div`
  width: 80%;
  height: 400px;
  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 95%;
    height: 200px;
  }
`;


// Welcome 区域
const WelcomeSection = styled.section`
  padding: 0 5rem 3rem;
  box-sizing: border-box;


  @media (max-width: 768px) {
    padding: 0 2rem 2rem;
  }
`;


const WelcomeTitle = styled.h2`
  font-size: 3rem;
  color: #0099ff;
  margin: 0 0 1rem 0;
  display: inline-block;
`;


const WelcomeText = styled.p`
  color: #333;
  line-height: 1.6;
  font-size: 1rem;
  max-width: 100%;
  margin: 0;
`;


// News 标题栏
const NewsHeader = styled.h3`
  font-size: 1.2rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  margin: 0 5rem 2rem;


  @media (max-width: 768px) {
    margin: 0 2rem 1.5rem;
  }
`;


// 展会图片网格（2 列布局）
const ExpoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  padding: 0 5rem 3rem;
  box-sizing: border-box;


  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }


  @media (max-width: 768px) {
    padding: 0 2rem 2rem;
  }
`;


// 展会图片卡片
const ExpoCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;


// 核心修改：让图片从左上角填充，保持比例且不拉伸变形
const ExpoImage = styled.img`
  width: 100%;
  height: 700px;
  object-fit: cover;
  object-position: top left;
  display: block;

  @media (max-width: 768px) {
    height: 300px;
  }
`;


const ExpoCaption = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin: 0.5rem 0 1rem 0;
  text-align: center;
  padding: 0 1rem;
`;


const NewsPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>News - Wisdom Home Appliances</title>
        <meta name="description" content="Wisdom exhibition news and company history" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>


      <NewsContainer>
        {/* 顶部 Banner */}
        <BannerSection>
          <BannerImage />
        </BannerSection>


        {/* Welcome 区域 */}
        <WelcomeSection>
          <WelcomeTitle>WELCOME</WelcomeTitle>
          <WelcomeText>
            To OEM and ODM consumer electronics, Home appliances, Small Home appliances, since 2006, we supply high quality and good service to our clients. Since 2019, we have started to sell our Wisdom brands products in Asia market by lazada. Now we have more than 500 SKU available for OEM and wholesale.
          </WelcomeText>
        </WelcomeSection>


        {/* News 标题 */}
        <NewsHeader>News</NewsHeader>


        {/* 展会图片网格 */}
        <ExpoGrid>
          <ExpoCard>
            <ExpoImage src={expo1} alt="2024 Global Sources Fair" />
            <ExpoCaption
               style={{
                fontSize: '20px',
                fontWeight: 'bold',
               }}
            >2024 Global sources Fair April 11-15</ExpoCaption>
          </ExpoCard>
          <ExpoCard>
            <ExpoImage src={expo2} alt="2024 Global Sources Fair" />
                        <ExpoCaption
               style={{
                fontSize: '20px',
                fontWeight: 'bold',
               }}
            >2024 Global sources Fair April 11-15</ExpoCaption>
          </ExpoCard>
          <ExpoCard>
            <ExpoImage src={expo3} alt="2019 Canton Fair" />
            <ExpoCaption
               style={{
                fontSize: '20px',
                fontWeight: 'bold',
               }}
            >2019 Canton Fair Oct 15-19</ExpoCaption>
          </ExpoCard>
          <ExpoCard>
            <ExpoImage src={expo4} alt="2018 Hong Kong TDC Fair" />
            <ExpoCaption
               style={{
                fontSize: '20px',
                fontWeight: 'bold',
               }}
            >2018 Hong Kong TDC Fair April 12-16</ExpoCaption>
          </ExpoCard>
          <ExpoCard>
            <ExpoImage src={expo5} alt="2017 Hong Kong TDC Fair" />
            <ExpoCaption
               style={{
                fontSize: '20px',
                fontWeight: 'bold',
               }}
            >2017 Hong Kong TDC Fair April 12-16</ExpoCaption>
          </ExpoCard>
          <ExpoCard>
            <ExpoImage src={expo6} alt="2016 Hong Kong TDC Fair" />
            <ExpoCaption
               style={{
                fontSize: '20px',
                fontWeight: 'bold',
               }}
            >2016 Hong Kong TDC Fair April 12-16</ExpoCaption>
          </ExpoCard>
        </ExpoGrid>
      </NewsContainer>
    </Layout>
  );
};


export default NewsPage;
